export const i18n = {
	lastUpdated: {
		id: 'search-page.filters.names.lastUpdated',
		defaultMessage: 'Last updated',
		description: 'Label for filtering by last updated time',
	},
};
